import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { northPlatteConfig } from "./data";

export default function NorthPlattePage() {
  return <CityPageTemplate config={northPlatteConfig} />;
}